import { ColumnChooserModel } from '../models/common/ColumnChooserModel'

/** Excel menüsündeki seçim: ekrandaki sayfa, işaretli satırlar ya da filtreye uyan tümü. */
export type ExcelExportMode = 'page' | 'selected' | 'all'

/**
 * Excel isteğini ekranın liste isteğinden üretir. Kolon filtreleri, sıralama ve (varsa)
 * paneldeki alanlar her durumda korunur:
 * - page: skip/take olduğu gibi (ekrandaki sayfa)
 * - selected: yalnız işaretli satırların kimlikleri (ids), sayfalama yok
 * - all: sayfalama yok, filtreye uyan bütün kayıtlar
 */
export function buildExcelRequest<T extends object>(
    filter: T,
    mode: ExcelExportMode,
    selectedIds: string[],
    columns: ColumnChooserModel[]
): T {
    const f: any = filter

    return {
        ...filter,
        skip: mode == 'page' ? f.skip : undefined,
        take: mode == 'page' ? f.take : undefined,
        ids: mode == 'selected' ? selectedIds : undefined,
        columnChooser: columns,
    } as T
}
